import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { AuthenticationService } from '@services/authentication.service';

/**
 * Default Class
 */
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {
    /** Environment Variables */
    public env: any = environment;

    /**
     * Default Cnstructor
     * @param auth Auth0 Login Details
     * @param authenticationService authenticationService
     * @param document Current Document Info
     */
    constructor(
        public auth: AuthService,
        private authenticationService: AuthenticationService,
        @Inject(DOCUMENT) public document: Document,) { }

    /**
     * Log Out back to original location
     */
    logout() {
        this.authenticationService.logout(document);
    }

    /**
     * Log in
     */
    logIn() {
        this.authenticationService.login();
    }
}
